import { render } from "./CustomerGroup.vue?vue&type=template&id=6e3e35e3&scoped=true"
import script from "./CustomerGroup.vue?vue&type=script&lang=js"
export * from "./CustomerGroup.vue?vue&type=script&lang=js"

import "./CustomerGroup.vue?vue&type=style&index=0&id=6e3e35e3&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3e35e3"]])

export default __exports__